import {Injectable} from '@angular/core'
import {TranslocoService} from '@ngneat/transloco'
import {mergeMap, Observable, of} from 'rxjs'
import {PageMetadata} from '../../../core/seo/page-metadata'
import {map} from 'rxjs/operators'

@Injectable()
export class JobRequestPageMetadataService {
  constructor(private readonly translationService: TranslocoService) {}

  /** Helper for setting page metadata in the job request pages */
  getPageMetadataForStep(step: Step, offering?: {label: string}): Observable<PageMetadata> {
    const offeringText$ = offering
      ? of(offering.label)
      : this.translationService.selectTranslate('createJobRequest.noOfferingLabel')
    const title$ = offeringText$.pipe(
      mergeMap(offering =>
        this.translationService.selectTranslate(this.pageTitleTranslationKeyForStep(step), {offering}),
      ),
    )
    return title$.pipe(map(title => ({title})))
  }

  private pageTitleTranslationKeyForStep(step: Step): string {
    switch (step) {
      case 'DETAILS':
        return 'createJobRequest.detail.pageTitle'
      case 'EXECUTION':
        return 'createJobRequest.time.pageTitle'
      case 'CONTACT':
        return 'createJobRequest.contact.pageTitle'
      case 'EXPECTATIONS':
        return 'createJobRequest.expectation.pageTitle'
      case 'INTENTIONS':
        return 'createJobRequest.intentions.pageTitle'
      case 'SUMMARY':
        return 'createJobRequest.summary.pageTitle'
    }
  }
}

type Step = 'INTENTIONS' | 'EXPECTATIONS' | 'DETAILS' | 'EXECUTION' | 'CONTACT' | 'SUMMARY'
